import "./index.css";
import App from "./App.svelte";

declare global {
  interface Window {
    app: App;
  }
}

const syncAiConfigToLocalStorage = () => {
  const STORAGE_KEY = "gruim-ai-chat-settings";
  
  const envMapping = {
    AI_PROVIDER: "modelType",
    AI_API_KEY: "secretToken",
    AI_MODEL: "selectedModel",
  };

  // Static access to ensure Webpack's DefinePlugin can perform replacement
  const envValues: Record<string, string | undefined> = {
    AI_PROVIDER: process.env.SVELTE_APP_AI_PROVIDER,
    AI_API_KEY: process.env.SVELTE_APP_AI_API_KEY,
    AI_MODEL: process.env.SVELTE_APP_AI_MODEL,
  };

  let settings: any = {};
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      settings = JSON.parse(stored);
    }
  } catch (e) {
    /* ignore parse errors */
  }

  let changed = false;
  Object.entries(envMapping).forEach(([envKey, storageKey]) => {
    const envValue = envValues[envKey];
    
    // Only set if env exists and storage is empty for this specific key
    if (envValue && !settings[storageKey]) {
      settings[storageKey] = envValue;
      changed = true;
    }
  });

  if (changed) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }
};

syncAiConfigToLocalStorage();

const app = new App({
  target: document.getElementById("app")!,
});

window.app = app;

export default app;
